import { render } from "./float-list.vue?vue&type=template&id=653107dd&scoped=true"
import script from "./float-list.vue?vue&type=script&lang=js"
export * from "./float-list.vue?vue&type=script&lang=js"

import "./float-list.vue?vue&type=style&index=0&id=653107dd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653107dd"]])

export default __exports__